// Chargement de Stripe.js — une seule fois pour toute l'application, avec deux nouvelles tentatives si le
// téléchargement échoue (réseau lent, coupure) : un échec ponctuel ne bloque plus le paiement jusqu'au rechargement
// de la page, et une balise restée en échec n'est jamais attendue indéfiniment.

export const STRIPE_JS_URL = 'https://js.stripe.com/v3/';
export const RETRY_DELAYS_MS = [1000, 3000];
export const LOAD_ERROR = 'Impossible de charger Stripe.js.';

let pending = null;

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

function injectOnce() {
  return new Promise((resolve, reject) => {
    if (window.Stripe) { resolve(window.Stripe); return; }
    // Balise d'un essai raté (ou laissée par une page quittée en cours de chargement) : le navigateur ne la
    // rechargera pas, on la remplace
    document.querySelectorAll(`script[src="${STRIPE_JS_URL}"]`).forEach((s) => s.remove());
    const s = document.createElement('script');
    s.src = STRIPE_JS_URL;
    s.async = true;
    s.onload = () => (window.Stripe ? resolve(window.Stripe) : reject(new Error(LOAD_ERROR)));
    s.onerror = () => { s.remove(); reject(new Error(LOAD_ERROR)); };
    document.head.appendChild(s);
  });
}

/** Promesse de `window.Stripe` ; après trois échecs elle est rejetée, et l'appel suivant recommence de zéro. */
export function loadStripeJs({ delays = RETRY_DELAYS_MS } = {}) {
  if (window.Stripe) return Promise.resolve(window.Stripe);
  if (!pending) {
    pending = (async () => {
      let lastError;
      for (let attempt = 0; attempt <= delays.length; attempt++) {
        if (attempt > 0) await wait(delays[attempt - 1]);
        try {
          return await injectOnce();
        } catch (e) {
          lastError = e;
        }
      }
      throw lastError;
    })().catch((e) => { pending = null; throw e; });
  }
  return pending;
}

export function resetStripeJsForTests() {
  pending = null;
}
